import React from "react"
import * as React_ from "elm-ts/lib/React"
import * as M from "../Model"
import { overviewView } from "./overviewView"
import { viewingsView } from "./viewingsView"
import { feedbackView } from "./feedbackView"
import { rentalsView } from "./rentalsView"
import { Layout, Error } from "../components"
import { flow, pipe } from "fp-ts/lib/function"
import * as E from "fp-ts/lib/Either"
import * as A from "fp-ts/lib/Array"
import * as O from "fp-ts/lib/Option"

export function view<msg>(
  config: M.Config<msg>
): (model: M.Model) => React_.Html<msg> {
  return model => dispatch =>
    (
      <Layout
        tab={model.tab}
        navigation={model.navigation}
        dashboard={model.dashboard}
        properties={model.properties}
        tabChanged={tab => dispatch(config.wrapperMsg(M.Msg.tabChanged(tab)))}
        dashboardChanged={propcode =>
          dispatch(config.wrapperMsg(M.Msg.dashboardChanged(propcode)))
        }
        logoutMsg={() => dispatch(config.logoutMsg())}
      >
        <>{dashboardView(config)(model)(dispatch)}</>
      </Layout>
    )
}

function dashboardView<msg>(
  config: M.Config<msg>
): (model: M.Model) => React_.Html<msg> {
  return model => dispatch => {
    switch (config.route._tag) {
      case "Home": {
        return pipe(
          model.properties,
          E.match(
            err => {
              switch (err) {
                case "Error": {
                  return (
                    <Error
                      dataCy="home-error"
                      message="Please try to refresh the page. If the error persist, please"
                    />
                  )
                }
                case "Not Authorized": {
                  return (
                    <Error
                      dataCy="home-error-auth"
                      message={pipe(
                        config.user.email,
                        O.fromNullable,
                        O.match(
                          () => "Login doesn't seem to be working. Please",
                          email =>
                            `Login with ${email} doesn't seem to be working. Are you sure this is the correct email address?. If the error persist, please`
                        )
                      )}
                    />
                  )
                }
                default: {
                  return <></>
                }
              }
            },
            properties =>
              A.isEmpty(properties) ? (
                <Error
                  dataCy="home-properties-empty"
                  message="Data not found. If this doesn't look right please"
                />
              ) : (
                <></>
              )
          )
        )
      }
      case "Dashboard": {
        switch (config.route.tab) {
          case "overview": {
            return overviewView(M.configOverview(config.route.propcode))(
              model.overviewModel
            )(flow(config.wrapperMsg, dispatch))
          }
          case "viewings": {
            return viewingsView(
              M.configViewings(config.user, config.route.propcode)
            )(model.viewingsModel)(flow(config.wrapperMsg, dispatch))
          }
          case "feedback": {
            return feedbackView(
              M.configFeedback(config.user, config.route.propcode)
            )(model.feedbackModel)(flow(config.wrapperMsg, dispatch))
          }

          case "rentals": {
            return rentalsView(
              M.configRentals(config.user, config.route.propcode)
            )(model.rentalsModel)(flow(config.wrapperMsg, dispatch))
          }
        }
      }

      default: {
        return <></>
      }
    }
  }
}
